// extracted by mini-css-extract-plugin
export default {"subtitle":"DialogHeader_subtitle__ZNW7x","title":"DialogHeader_title__h3yPG","header":"DialogHeader_header__E-43f"};